import { render, staticRenderFns } from "./TrafficSources.vue?vue&type=template&id=2e7a83a4&scoped=true"
import script from "./TrafficSources.vue?vue&type=script&lang=js"
export * from "./TrafficSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a83a4",
  null
  
)

export default component.exports